<body style="text-align: center;">
  <div style="background-color: white;">
    <img width="200" height="150" src="../../../assets/images/Logo.png">
  </div>
  <mat-card style="margin-top:25px">
    <mat-card-title>{{'login' | translate}}</mat-card-title>
    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="submit()">
        <p>
          <mat-form-field appearance="standard">
            <input type="text" matInput placeholder="{{'userName' | translate}}" formControlName="username">
          </mat-form-field>
        </p>

        <p>
          <mat-form-field appearance="standard">
            <input [type]="hidePassword ? 'password' : 'text'" matInput placeholder="{{'password' | translate}}"
              formControlName="password">
            <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword"
              [attr.aria-label]="hidePassword ? 'Show password' : 'Hide password'" [attr.aria-pressed]="!hidePassword">
              <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
          </mat-form-field>
        </p>

        <p>
          <mat-form-field appearance="standard">
            <mat-select [(value)]="selectedLang" (selectionChange)="selectChange()">
              <mat-option *ngFor="let item of lang" [value]="item.id">
                {{item.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </p>

        <p *ngIf="error" class="error">
          {{ error }}
        </p>

        <div class="button">
          <button type="submit" mat-raised-button color="primary" [disabled]="form.invalid">{{'login' |
            translate}}</button>
        </div>

        <div class="text-right">

          <a routerLink="./resetpass" routerLinkActive="router-link-active">{{'forgetpassword' | translate}}</a>
        </div>

      </form>
    </mat-card-content>
  </mat-card>

  <app-matspinner [overlay]="spinnerOverlay"></app-matspinner>
</body>